module.exports = __webpack_public_path__ + "img/media_6.15603821.webp";